import { Auth0ClientOptions } from '@auth0/auth0-spa-js';

import { AmplifyAuthConfig, Authenticator, isAuth0Authenticated } from '../../authenticator';
import { ROUTES } from '../constants';
import { auth0Authenticator } from './auth0-authenticator';
import { getAuthenticator as getAmplifyAuthenticator } from './authenticator';

let _instance: Authenticator<AmplifyAuthConfig | Auth0ClientOptions> | undefined;

// SageID sign in and sign up will start from /sso/sageid page and on that
// page auth0 authenticator needs to be initialized. Also if there are auth0 auth fields in local storage,
// auth0 authenticator needs to be initialized. In all other situations Amplify authenticator needs to be initialized.
if (window.location.pathname.includes(ROUTES.SAGE_ID_SIGN_IN_TRIGGER) || isAuth0Authenticated()) {
  _instance = auth0Authenticator;
} else {
  _instance = getAmplifyAuthenticator();
}

const appAuthenticator = _instance;

export { appAuthenticator };
